import { call, options, params } from './helpers';

// Get all user's signatures
export const getEsignatures = (payload) =>
	call(`/beta/esignatures${params(payload)}`);

// Get user's default signature
export const getDefaultEsignature = () =>
	call('/beta/esignatures/default');

// Get single signature
export const getEsignature = ({ id }) =>
	call(`/beta/esignatures/${id}`);

// Create new signature
export const createEsignature = (payload) =>
	call('/beta/esignatures', options(payload, 'POST'));

// Update signature
export const updateEsignature = ({ id, ...payload }) =>
	call(`/beta/esignatures/${id}`, options(payload, 'PUT'));

// Delete signature
export const deleteEsignature = ({ id }) =>
	call(`/beta/esignatures/${id}`, options(null, 'DELETE'));
